import React from 'react';
import { Bar } from 'react-chartjs-2';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { ChartContainer, ChartTitle } from './styles';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const VisitProfileChart = ({ data }) => {
    const chartData = {
        labels: ['Meia visita', 'Visita inteira'],
        datasets: [
            {
                label: 'Previsto',
                data: [data?.halfVisit?.planned || 0, data?.fullVisit?.planned || 0],
                backgroundColor: '#10B7DC'
            },
            {
                label: 'Executado',
                data: [data?.halfVisit?.executed || 0, data?.fullVisit?.executed || 0],
                backgroundColor: '#62C054'
            }
        ]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 30,
                    boxWidth: 10,
                    boxHeight: 10
                }
            },
            datalabels: {
                display: false
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                grace: '20%',
                ticks: {
                    stepSize: 1,
                    callback: (value) => (Number.isInteger(value) ? value : null)
                },
                grid: {
                    color: '#f0f0f0'
                }
            },
            y: {
                grid: {
                    display: false
                },
                ticks: {
                    padding: 10
                },
                categoryPercentage: 0.5,
                barPercentage: 0.7
            }
        }
    };

    return (
        <ChartContainer>
            <ChartTitle>Perfil de visitas</ChartTitle>
            <div style={{ height: '250px' }}>
                <Bar data={chartData} options={options} />
            </div>
        </ChartContainer>
    );
};

export default VisitProfileChart;
